export const mockSessionData = {
  cacheData: {
    data: {
      consumerID: '',
      accessToken: '',
      Prearrival: {
        brandCode: 'rz',
      },
    },
  },
};
